import DashboardButtons from './DashboardButtons';

export default DashboardButtons;
export { DashboardButtons };
